exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ce44b3c6] .el-table{font-size:13px}[data-v-ce44b3c6] .el-table .cell{line-height:14px}[data-v-ce44b3c6] .info-form .el-form-item{margin-bottom:15px}[data-v-ce44b3c6] .info-form .el-form-item__label{line-height:20px;padding-bottom:5px}[data-v-ce44b3c6] .info-form .el-input .el-input__inner{border-color:#fff!important}", ""]);

// exports
